var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.04,
    height: 20.04,
    viewBox: "0 0 20.04 20.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#898e9a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.13,3.125a2.016,2.016,0,0,0-2,2V21.16a2.016,2.016,0,0,0,2,2h8.015V21.828H5.13a.652.652,0,0,1-.668-.668V5.13a.653.653,0,0,1,.668-.669H17.154a.65.65,0,0,1,.665.669V9.137h1.337V5.13a2.013,2.013,0,0,0-2-2Z",
    transform: "translate(-3.125 -3.125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.13,34.371a2.016,2.016,0,0,0-2,2v9.352a2.016,2.016,0,0,0,2,2h5.343a2.016,2.016,0,0,0,2-2V36.376a2.016,2.016,0,0,0-2-2Zm0,1.336h5.343a.652.652,0,0,1,.668.668v9.352a.652.652,0,0,1-.668.668H55.13a.652.652,0,0,1-.668-.668V36.375A.652.652,0,0,1,55.13,35.707Z",
    transform: "translate(-42.437 -27.692)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.211,81.918a.667.667,0,1,1-.2-.473.668.668,0,0,1,.2.473Z",
    transform: "translate(-57.179 -64.55)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.836,81.918a.667.667,0,1,1-.2-.473.668.668,0,0,1,.2.473Z",
    transform: "translate(-30.152 -64.55)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPreview);
export default __webpack_public_path__ + "static/media/picto-preview.88fcacc54bb32e9d44a6759d8123898b.svg";
export { ForwardRef as ReactComponent };